import { FileDownloadOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';

interface IProps {
  onClick: () => void;
  disabled?: boolean;
}

const CampaignExportButton = ({ onClick, disabled = false }: IProps) => {
  return (
    <Button
      variant='outlined'
      sx={{
        height: '32px',
        borderRadius: '50px',
        border: '1px solid #C4D0CB',
        padding: '6px 12px',
        whiteSpace: 'nowrap',
      }}
      color='primary'
      startIcon={<FileDownloadOutlined />}
      onClick={onClick}
      disabled={disabled}
    >
      Campaign Export
    </Button>
  );
};

export default CampaignExportButton;
